export default "__VITE_ASSET__BAp60Pg4__"